import YFormSubscriptionModalButton from './SubscriptionModalButton';

export { YFormSubscriptionModalButton };
export default YFormSubscriptionModalButton;
